export default __webpack_public_path__ + "static/media/ic-nica-logo-large-knockout.8454b796.svg";